import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc, addDoc, collection } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";

const DetailOfferPage = () => {
  const { offerId } = useParams();
  const [offer, setOffer] = useState(null);
  const [bookingRequest, setBookingRequest] = useState({
    name: "",
    email: "",
    date: "",
    people: "",
    message: "",
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOffer = async () => {
      try {
        const offerDoc = await getDoc(doc(db, "offers", offerId));
        if (offerDoc.exists()) {
          setOffer({ id: offerDoc.id, ...offerDoc.data() });
        } else {
          alert("العرض غير موجود");
          navigate("/OffersPage");
        }
      } catch (error) {
        console.error("خطأ في تحميل العرض:", error);
        alert("خطأ في تحميل العرض");
      } finally {
        setLoading(false);
      }
    };

    fetchOffer();
  }, [offerId, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBookingRequest((prev) => ({ ...prev, [name]: value }));
  };

  const handleBookingSubmit = async (e) => {
    e.preventDefault();

    if (!bookingRequest.name || !bookingRequest.email || !bookingRequest.date || !bookingRequest.people) {
      alert("يرجى تعبئة جميع الحقول المطلوبة");
      return;
    }

    try {
      const bookingData = {
        offerId: offer.id,
        offerName: offer.name,
        ...bookingRequest,
      };

      await addDoc(collection(db, "bookings"), bookingData);
      alert("تم تقديم طلب الحجز بنجاح!");
      setBookingRequest({ name: "", email: "", date: "", people: "", message: "" });
    } catch (error) {
      console.error("خطأ في تقديم طلب الحجز:", error);
      alert("فشل في تقديم طلب الحجز. يرجى المحاولة مرة أخرى.");
    }
  };

  if (loading) {
    return <Loader />;
  }

  if (!offer) {
    return <div>العرض غير موجود.</div>;
  }

  return (
    <div className="w-full h-full bg-[#047857] p-4">
      <div className="max-w-4xl w-full mx-auto p-6 shadow-xl bg-gray-50 rounded-lg">
        <h1 className="text-3xl font-bold mb-4">{offer?.name}</h1>
        <img
          src={offer?.image}
          alt={offer?.name}
          className="w-full h-64 object-cover rounded-md mb-4"
        />
        <p className="text-lg mb-2">
          <strong>نوع الخدمة:</strong> {offer?.serviceType}
        </p>
        <p className="text-lg mb-2">
          <strong>الموقع:</strong> {offer?.city}, {offer?.country}
        </p>
        <p className="text-lg mb-4">
          <strong>السعر:</strong> ${offer?.price}
        </p>
        <p className="text-gray-700 mb-6">{offer?.description}</p>

        <h2 className="text-2xl font-bold mb-4">طلب الحجز</h2>
        <form onSubmit={handleBookingSubmit} className="space-y-4">
          <input
            type="text"
            name="name"
            value={bookingRequest.name}
            onChange={handleChange}
            placeholder="اسمك"
            required
            className="w-full px-4 py-2 border rounded-md"
          />
          <input
            type="email"
            name="email"
            value={bookingRequest.email}
            onChange={handleChange}
            placeholder="بريدك الإلكتروني"
            required
            className="w-full px-4 py-2 border rounded-md"
          />
          <input
            type="date"
            name="date"
            value={bookingRequest.date}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border rounded-md"
          />
          <input
            type="number"
            name="people"
            value={bookingRequest.people}
            onChange={handleChange}
            placeholder="عدد الأشخاص"
            required
            className="w-full px-4 py-2 border rounded-md"
          />
          <textarea
            name="message"
            value={bookingRequest.message}
            onChange={handleChange}
            rows="4"
            placeholder="رسالة إضافية (اختياري)"
            className="w-full px-4 py-2 border rounded-md"
          ></textarea>
          <button
            type="submit"
            className="w-full bg-[#047857] text-white py-2 rounded-md hover:bg-[#26B75D]"
          >
            تقديم الطلب
          </button>
        </form>
      </div>
    </div>
  );
};

export default DetailOfferPage;
